import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=2fc615f8&scoped=true&"
import script from "./Clients.vue?vue&type=script&lang=js&"
export * from "./Clients.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/components/cards/card.css?vue&type=style&index=0&id=2fc615f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc615f8",
  null
  
)

export default component.exports